import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Route, withRouter, Redirect } from 'react-router-dom';

const PrivateRoute = ({
  component: Component,
  userRole,
  allowRole,
  ...rest
}) => {
  let render;
  if (userRole !== allowRole) {
    render = () => (
      <Redirect
        to={{
          pathname: '/login',
        }}
      />
    );
  } else {
    render = props => <Component {...props} />;
  }

  return <Route {...rest} render={render} />;
};

PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
  userRole: PropTypes.number.isRequired,
  allowRole: PropTypes.number.isRequired,
};

const mapStateToProps = state => ({
  userRole: state.user.role,
});

export default withRouter(connect(mapStateToProps)(PrivateRoute));
